import IsAxiosError from 'components/common/IsAxiosError';
import Loading from 'components/common/Loading';
import HubertCombobox from 'components/HubertUI/HubertCombobox';
import { useGetScoringCategoriesQuery } from 'rtk/query/apis/misc';

interface Props {
  onValueChange: (value: string | string[]) => void;
  value: string;
  placeholder?: string;
  triggerClassName?: string;
  contentClassName?: string;
  isMulti?: boolean;
  disabled?: boolean;
}

const ScoringCategoryCombobox = ({
  onValueChange,
  value,
  triggerClassName = '',
  contentClassName = '',
  isMulti = false,
  disabled = false,
  ...props
}: Props) => {
  const { data, isLoading, isFetching, isError, error } = useGetScoringCategoriesQuery();

  // useEffect(() => {
  //   if (data) {
  //     setCategories([{ label: ' - ', value: null, description: '' }].concat(data))
  //   }
  // }, [data]);

  if (isLoading || isFetching) {
    return <Loading label="scoring categories" />;
  }

  if (isError) {
    return <IsAxiosError error={error} />;
  }

  if (!data) {
    return null;
  }

  return (
    <div {...props}>
      <HubertCombobox
        itemName="scoring category/ies"
        isMulti={isMulti}
        items={data.scoringCategories}
        onValueChange={onValueChange}
        value={value}
        disabled={disabled}
        triggerClassName={triggerClassName}
        contentClassName={contentClassName}
      />
    </div>
  );
};

export default ScoringCategoryCombobox;
